export const PERMISSION_RESOURCE_CODES = {
  storageProviderConfig: 'storage-provider-config',
  storageBucketManagement: 'storage-bucket-management',
  storageObjectBrowser: 'storage-object-browser',
  storageAuditLog: 'storage-audit-log',
  applicationStorageConfig: 'application-storage-config',
  permissionManage: 'permission-manage',
} as const;

export const PERMISSION_ACTION_CODES = {
  storageProviderConfig: {
    view: 'view',
    query: 'query',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    test: 'test',
  },
  storageBucketManagement: {
    view: 'view',
    query: 'query',
    create: 'create',
    edit: 'edit',
  },
  storageObjectBrowser: {
    view: 'view',
    query: 'query',
    search: 'search',
    create: 'create',
    upload: 'upload',
    preview: 'preview',
    download: 'download',
    share: 'share',
    delete: 'delete',
  },
  storageAuditLog: {
    view: 'view',
    query: 'query',
    filter: 'filter',
  },
  applicationStorageConfig: {
    view: 'view',
    query: 'query',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  permissionManage: {
    /** 控制设置弹窗内"权限管理"Tab 的可见性 */
    view: 'view',
    /** 控制"导入当前应用权限资源"按钮的可见性 */
    manage: 'manage',
  },
} as const;
